export function isDev() {
  return process.env.NODE_ENV === "development";
}

export function isLocalhost() {
  return window.location.hostname === "localhost";
}
